import React, { useRef } from 'react';
import Card from 'screens/shared/card';
import Icon from 'screens/shared/icon';
import { CircularProgress, Button } from '@mui/material';

const _actionButtons = {
  edit: {
    color: 'var(--color-success)',
    name: 'edit',
  },
  delete: {
    color: 'var(--color-danger)',
    name: 'trash',
  },
  arrow: {
    name: 'chevron-right',
  },
  arrowDown: {
    name: 'chevron-down',
  },
  external: {
    name: 'external-link-alt',
  },
};

export default ({
  image,
  icon,
  iconFill = '#9a9a9a',
  iconText = '',
  title,
  details,
  className,
  buttons = [], // { color, name, onClick, style ...htmlProps}
  others = '',
  onClick = null,
  isLoader = false,
  isArrow = true,
  iconAlign = 'center', // top, center, bottom
  actionButtons: actionButtonsProps = {},
  ...props
}) => {
  const logoDivRef = useRef(null);
  const height = logoDivRef.current ? logoDivRef.current.clientHeight : 0;
  const actionButtons = Object.keys(actionButtonsProps)
    .map((e) => actionButtonsProps[e] && ({ ..._actionButtons[e], click: actionButtonsProps[e] }))
    .filter((item) => item);

  return (
    <Card
      className={`cards-basic ${className}`}
      isArrow={!!onClick && isArrow && !isLoader}
      onClick={() => (!isLoader && !!onClick ? onClick() : null)}
      {...props}
    >
      <div
        ref={logoDivRef}
        className={`cards-basic-logo cards-basic-logo-align-${iconAlign} cards-basic-logo-${!details ? 'sm' : 'lg'} ${iconText ? 'cards-basic-logo-text' : ''}`}
      >
        {!!image && <img src={image} alt="..." style={{ background: iconFill }} />}
        {!!icon && <Icon name={icon} style={{ background: iconFill }} />}
        {!!iconText && (
          <span
            style={{
              fontSize: iconText.length > 5 ? (iconText.length > 7 ? 6 : 9) : 10,
              top: height ? ((height - 51) / 2) + 34 : 34,
            }}
          >
            {iconText}

          </span>
        )}
      </div>

      <div className="cards-basic-body">
        <h3 title={title}>
          {title}
        </h3>
        {!!details && (
          <h4 style={{ wordBreak: 'break-all' }}>
            {details}
          </h4>
        )}

        {!!others && others}
      </div>

      <div className="cards-basic-buttons">
        {isLoader && (
          <CircularProgress
            style={{
              width: 22, height: 22, float: 'right', marginRight: 5,
            }}
            className="loader"
          />
        )}

        {!isLoader && buttons.map(({
          color, name, style, ...rest
        }) => {
          if (rest.title) {
            return (
              <Button
                variant="outlined"
                key={`btn_${name}`}
                name={name}
                classes={{ root: 'shadow border-none m-l-5 m-r-5' }}
                startIcon={!!name && (
                  <Icon
                    name={name}
                    style={{
                      boxShadow: 'none', padding: 'unset', margin: '0 -8px 0 0', fontSize: 14, color,
                    }}
                  />
                )}
                {...rest}
                style={{
                  padding: '4px 8px', color, ...style,
                }}
              >
                {rest.title}
              </Button>
            );
          }
          return <Icon key={name} name={name} {...rest} style={{ color, ...style }} />;
        })}

        {!isLoader && actionButtons.map(({
          color, name, click,
        }) => (<Icon key={name} name={name} style={{ color }} onClick={click} />))}
      </div>
    </Card>
  );
};
